<div class='jk-component jk-border-range'>

  <app-jkcombobox [(value)]="to" [items]="languageList"></app-jkcombobox>
  <app-jktextarea [(value)]="translate"></app-jktextarea>
  <app-jktextarea [(value)]="translateResult"></app-jktextarea>
  <mat-toolbar>
    <button [class.btn-primary]="true" (click)="doTranslate($event)">
      翻譯-azure
    </button>
    <button [class.btn-primary]="true" (click)="doTTS($event)">
      中轉語音-azure
    </button>
  </mat-toolbar>
</div>
